import * as React from "react";
import { SVGProps } from "react";
export const EnvelopeIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M3.41699 16.667C2.93099 16.667 2.51766 16.4967 2.17699 16.156C1.83699 15.816 1.66699 15.403 1.66699 14.917V5.08301C1.66699 4.59701 1.83699 4.18401 2.17699 3.84401C2.51766 3.50334 2.93099 3.33301 3.41699 3.33301H16.583C17.069 3.33301 17.4823 3.50334 17.823 3.84401C18.163 4.18401 18.333 4.59701 18.333 5.08301V14.917C18.333 15.403 18.163 15.816 17.823 16.156C17.4823 16.4967 17.069 16.667 16.583 16.667H3.41699ZM16.583 6.83301L10.458 10.646C10.3887 10.6873 10.316 10.722 10.24 10.75C10.1633 10.778 10.0833 10.792 9.99999 10.792C9.91666 10.792 9.83666 10.778 9.75999 10.75C9.68399 10.722 9.61133 10.6873 9.54199 10.646L3.41699 6.83301V14.917H16.583V6.83301ZM9.99999 9.20801L16.625 5.08301H3.39599L9.99999 9.20801ZM3.41699 7.04201V5.77101V5.79201V5.78101V7.04201Z"
            fill="currentColor"
        />
    </svg>
);
EnvelopeIcon.displayName = "EnvelopeIcon";
